import React from "react";

const renderErrors = (errors) => {
  return (
    <div role="alert">
      {Object.keys(errors).map((key, index) => {
        const catError =
          errors[key] === "No cat found. Please upload another photo";
        const sentences = catError ? errors[key].split(".") : null;

        return (
          <div key={index}>
            {catError ? (
              <>
                <p className="api-message">
                  {`${key.replace(/^\w/, (c) => c.toUpperCase())}: ${
                    sentences[0]
                  }`}
                </p>
                <p className="api-message">{`${sentences[1]}`}</p>
              </>
            ) : (
              <p key={index} className="api-message">
                {`${key.replace(/^\w/, (c) => c.toUpperCase())}: ${
                  errors[key]
                }`}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default renderErrors;
